module.exports = __webpack_public_path__ + "static/media/Voucher.a429e299.svg";